import React from 'react'
import { Label } from 'react-bootstrap'

export function EditorRoomName ({ room }) {
  if (!room.name) {
    return null
  }

  return (
    <div className='editor-room-name'>
      {room.name}{' '}
      {room.isRentable ? (
        <Label bsStyle='success'>Rentable</Label>
      ) : (
        <Label bsStyle='warning'>Not Rentable</Label>
      )}
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/ui/editorComponents.js